import { useState } from "react";
import { Dropdown, Modal, Col, Row, Space, Typography, message } from "antd";
import RolesView from "../components/RolesView";
import RoleFormDialog from "../components/RoleFormDialog";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getCompanyUserRolesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { CompanyRole } from "../repository/data.default";
import { RoleForm } from "../components/RoleFormDialog.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function RolesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [roleInputMode, setRoleInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [roleInputOpen, setRoleInputOpen] = useState(false);
  const [roleInputValues, setRoleInputValues] = useState<RoleForm>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onRoleInputOpen(
    mode: "add" | "update" | "delete",
    values?: CompanyRole,
  ): void {
    setRoleInputMode(mode);
    setRoleInputOpen(true);
    setRoleInputValues(
      values
        ? {
            uid: values.uid,
            rowVersion: values.rowVersion,
            name: values.name,
            description: values.description,
            isManager: values.isManager,
            company: {
              display: values.companyName,
              value: values.companyUid,
            },
          }
        : ({} as any),
    );
  }

  function onRoleInputFinish(): void {
    setRoleInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onRoleInputClose(): void {
    setRoleInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading roles export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getCompanyUserRolesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4 pl-0 pr-0">
          <Typography.Title className="m-0" level={4}>
            Company Roles
          </Typography.Title>
          <Row className="flex flex-auto flex-row justify-end">
            <Space className="flex flex-row">
              <Dropdown.Button
                type="primary"
                disabled={!permissions.can("CompanyRoles", "create")}

                className={`${!permissions.can("CompanyRoles", "create") ? "disabled" : ""}`}
                menu={{
                  items: [
                    {
                      key: "downloadExport",
                      label: "Export to Excel",
                      disabled: !permissions.can("CompanyRoles", "view"),
                      onClick: onDownloadExport,
                    },
                  ],
                }}
                onClick={() => onRoleInputOpen("add")}
              >
                Add Role
              </Dropdown.Button>
            </Space>
          </Row>
        </Row>
        <RolesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onRoleInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <RoleFormDialog
        mode={roleInputMode}
        open={roleInputOpen}
        initialValues={roleInputValues}
        onFinish={onRoleInputFinish}
        onCancel={onRoleInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default RolesPage;
